import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../api-services/api-service';

// Thunk for creating ad
export const createAd = createAsyncThunk('ads/createAd', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.createAd(empId, acessToken, payload);
  return response;
});

// Thunk for updating ad
export const updateAd = createAsyncThunk('ads/updateAd', async ({ adminData, payload }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.updateAd(empId, acessToken, payload);
  return response;
});

// Thunk for deleting ad
export const deleteAd = createAsyncThunk('ads/deleteAd', async ({ adminData, adId }) => {
  const { id: empId, acessToken } = adminData;
  const response = await apiService.deleteAd(empId, acessToken, adId);
  return response;
});

const adsSlice = createSlice({
  name: 'ads',
  initialState: {
    loading: false,
    error: null,
    success: false,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
    deleteLoading: false,
    deleteError: null,
    deleteSuccess: false,
  },
  reducers: {
    clearAdState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.updateLoading = false;
      state.updateError = null;
      state.updateSuccess = false;
      state.deleteLoading = false;
      state.deleteError = null;
      state.deleteSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create ad
      .addCase(createAd.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createAd.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(createAd.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })
      // Update ad
      .addCase(updateAd.pending, (state) => {
        state.updateLoading = true;
        state.updateError = null;
        state.updateSuccess = false;
      })
      .addCase(updateAd.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        state.updateError = null;
      })
      .addCase(updateAd.rejected, (state, action) => {
        state.updateLoading = false;
        state.updateError = action.error.message;
        state.updateSuccess = false;
      })
      // Delete ad
      .addCase(deleteAd.pending, (state) => {
        state.deleteLoading = true;
        state.deleteError = null;
        state.deleteSuccess = false;
      })
      .addCase(deleteAd.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        state.deleteError = null;
      })
      .addCase(deleteAd.rejected, (state, action) => {
        state.deleteLoading = false;
        state.deleteError = action.error.message;
        state.deleteSuccess = false;
      });
  },
});

export const { clearAdState } = adsSlice.actions;
export default adsSlice.reducer;